import { styled } from '@mui/material/styles';

export const FileUploadWrapper = styled('div')(({ theme }) => ({
    '& .files-dropzone': {
        margin: '0 0 5px',
        padding: '10px',
        borderRadius: '4px',
        border: `1px dashed ${theme.palette.text.disabled}`,
        textAlign: 'center',
        cursor: 'pointer',

        '&.error': {
            border: `1px solid ${theme.palette.error.main}`,
        },

        '& .MuiSvgIcon-root': {
            fill: theme.palette.text.secondary,
        },
    },

    '& .files-upload-area-text': {
        display: 'block',
        margin: '2px 0',
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 500,
        color: theme.palette.text.secondary,
    },

    '& .files-info-text': {
        display: 'block',
        fontSize: theme.typography.pxToRem(14),
        color: theme.palette.text.disabled,
    },

    '& .files-info-text-small': {
        fontSize: theme.typography.pxToRem(12),
    },

    '& .files-btn-hold': {
        display: 'flex',
        justifyContent: 'flex-end',

        '& .MuiButton-root': {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: theme.typography.pxToRem(14),
            color: theme.palette.text.secondary,
            textDecoration: 'underline',
        },
    },

    '& .files-list-holder': {
        marginTop: '5px',
    },

    '& .files-list': {
        margin: '0',
        padding: '0',
        listStyle: 'none',
    },

    '& .files-list-item': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        margin: '0 0 15px',
        padding: '0 0 15px',
        borderBottom: `1px solid ${theme.palette.divider}`,

        '&:first-of-type': {
            paddingTop: '15px',
            borderTop: `1px solid ${theme.palette.divider}`,
        },
    },

    '& .files-list-preview-image': {
        maxWidth: '100%',
        borderRadius: '2px',
    },

    '& .files-list-content': {
        flexGrow: 1,
        paddingRight: '40px',
    },

    '& .files-list-content-name': {
        margin: '0 0 5px 0',
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 500,
        wordBreak: 'break-word',
    },

    '& .files-list-content-size': {
        fontSize: theme.typography.pxToRem(14),
        color: theme.palette.text.disabled,
    },

    '& .files-list-remove': {
        position: 'absolute',
        top: '50%',
        right: '0',
        transform: 'translateY(-50%)',
        cursor: 'pointer',

        '& .MuiSvgIcon-root': {
            fill: theme.palette.text.secondary,
        },
    },

    '& .files-list-preview-card': {
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff',
        border: '1px solid #ddd',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },

    '& .files-list-preview-extension': {
        fontSize: '32px',
        fontWeight: 'bold',
        color: '#666',
        textTransform: 'uppercase',
        letterSpacing: '1px',
    },

    // Make sure the preview container has fixed dimensions
    '& .files-list-preview': {
        width: '100px',
        height: '100px',
        flexShrink: 0,
        marginRight: '16px', // ← Add this line for spacing
    },

}));

export default FileUploadWrapper;
